// External Packages
import { ThemeProvider } from '@material-ui/styles'
import ParticleBackground from 'react-particle-backgrounds'
import React, { useEffect } from 'react'
// Internal Imports
import './App.css'
import Home from './Routes/Home/Home'
import useStyles from './AppStyles'
import theme from './theme'
import * as FIREBASE from './Services/firebase'

function App() {

    const classes = useStyles()

    const particleSettings = {
        canvas: {
            canvasFillSpace: true,
            width: 200,
            height: 200,
            useBouncyWalls: false
        },
        particle: {
            particleCount: 50,
            color: '#808080',
            minSize: 2,
            maxSize: 5
        },
        velocity: {
            directionAngle: 0,
            directionAngleVariance: 360,
            minSpeed: 0.5,
            maxSpeed: 1
        },
        opacity: {
            minOpacity: 0,
            maxOpacity: 0.5,
            opacityTransitionTime: 3000
        }
    }    

    useEffect(() => {
        FIREBASE.initApp()
    })

    return (
        <div className="App">
            <div className={classes.particles}>
                <ParticleBackground settings={particleSettings} />
            </div>
            <ThemeProvider theme={theme}>
                <div className={classes.mainContainer}> 
                    <Home/>
                </div>
            </ThemeProvider>
        </div>
    )
}

export default App;
